<template>
    <section class="flex-item-browser">
        <template v-if="isLoading">
            <loading-component />
        </template>

        <template v-else>
            <vue-custom-scrollbar
                tagname="section"
                style="height: 100%;"
            >
                <div class="flex-item-browser__items">
                    <ul v-if="hasItems" class="flex-item-browser__thumbnails">
                        <li
                            v-for="item in items"
                            :key="item.id"
                            class="flex-item-browser__thumbnail"
                            @click="selectItem(item)"
                        >
                            <thumbnail
                                :image="item.image || defaultItemImg"
                                :text="item.name"
                                :is-selected="selectedItems[item.id]"
                            />
                        </li>
                    </ul>
                    <div v-else class="flex-item-browser__thumbnails-text">
                        No {{ itemType }}s available
                    </div>
                </div>
            </vue-custom-scrollbar>

            <div class="flex-item-browser__actions">
                <button
                    class="flex-item-browser__select"
                    :disabled="!items.length"
                    @click="useSelectedItem"
                >
                    {{ templateMode ? 'Edit' : 'Choose' }} this {{ itemType }}
                </button>

                <button
                    v-if="templateMode"
                    class="flex-item-browser__select"
                    @click="createNew"
                >
                    Create New {{ itemType }}
                </button>
            </div>
            <div class="flex-item-browser__preview">
                <thumbnail
                    v-if="selectedItem"
                    :image="selectedItem.image || defaultItemImg"
                    :text="selectedItem.name"
                    :is-selected="true"
                />
                <div v-else class="flex-item-browser__preview-text">
                    Select a {{ itemType }}
                </div>
            </div>
        </template>
    </section>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import LoadingComponent from '@/components/shared/loading/loading-component';
import Thumbnail from './thumbnail';

export default {
    name: 'item-browser',

    components: {
        LoadingComponent,
        Thumbnail,
        vueCustomScrollbar,
    },

    props: {
        isVisible: {
            type: Boolean,
            default: true,
        },

        templateMode: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isLoading: true,

            items: [],
            selectedItems: {},
            selectedItem: null,
            showDrawer: true,

            // must be set in extended component
            itemType: 'type',
            defaultItemImg: 'importImg',

            scrollSettings: {
                suppressScrollX: true,
            },

        };
    },

    computed: {
        hasItems() {
            return !!this.items.length;
        },
    },

    watch: {
        async isVisible(val) {
            if (val) {
                await this.loadItems();
            }
        },
    },

    async created() {
        await this.loadItems();
        this.setDefault();
        this.isLoading = false;
    },

    methods: {
        async loadItems() {
            // Must override
            // await this.loadTemplates();
            // this.items = this.templates;
        },

        createNew() {
            this.$emit('create-new');
        },

        setDefault() {
            if (this.hasItems) {
                this.selectedItem = this.items[0];
                this.$set(this.selectedItems, this.selectedItem.id, true);
            }
        },

        selectItem(item) {
            if (this.selectedItem.id === item.id) {
                return;
            }
            this.$set(this.selectedItems, this.selectedItem.id, false);
            this.selectedItem = item;
            this.$set(this.selectedItems, this.selectedItem.id, true);
        },

        useSelectedItem() {
            this.$emit('selected', this.selectedItem);
        },
    },
};
</script>

<style lang="scss">
@import '@/styles/_includes.scss';

.flex-item-browser {
    display: grid;
    grid-template-columns: 65% 35%;
    grid-template-rows: 85% 15%;
    grid-template-areas:
        "items preview"
        "button preview";

    height: calc(100vh - 83px);
    width: 1200px;

    &__items {
        grid-area: items;
        overflow-y: auto;
        padding: 1rem;
    }

    &__thumbnails {
        display: flex;
        list-style: none;
        flex-direction: row;
        flex-wrap: wrap;
        padding-left: 0;
    }

    &__thumbnail {
        width: 25%;
    }

    &__thumbnails-text {
        text-align: center;
        font-size: 24px;
        padding: 20px;
    }

    &__actions {
        grid-area: button;
        grid-area: 2;
        display: flex;
        align-content: center;
        justify-content: space-around;
        margin-bottom: 1rem;
    }

    &__select {
        border-radius: 3px;
        display: inline-block;
        font-weight: 400;
        font-size: 18px;
        padding: 1rem;
        width: 300px;
        margin: auto;
        color: var(--form-buttonColor);
        background-color: var(--form-buttonBackgroundColor);
        border: 1px solid var(--form-buttonBorderColor);

        &:hover {
            color: var(--form-buttonHoverColor);
            background-color: var(--form-buttonHoverBackgroundColor);
        }

        &:disabled,
        &[disabled] {
            cursor: no-drop;
            opacity: 0.4;
        }
    }

    &__preview {
        grid-area: preview;
        text-align: center;
        padding: 30px;
    }

    &__preview-text {
        font-size: 24px;
        padding: 20px;
    }
}
</style>
